import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import LoginPage from "./components/features/auth/login";
import DashbordPage from "./components/features/dashboard/dashboard";
import SimpleMap from "./components/common/custom-map/custom-map.js";
import QuestionBasedGraph from "./components/features/question-based-graph/question-based-graph";
import SelectDatabase from "./components/features/select-database/select-database";
import UploadCsvPage from "./components/features/upload-csv/upload-csv";
import Layout from "./components/layout/layout";
import "./style.css";
import "bootstrap/dist/css/bootstrap.min.css";
<link
  rel="stylesheet"
  href="https://unpkg.com/leaflet@1.7.1/dist/leaflet.css"
/>;

const root = createRoot(document.getElementById("root"));
const App = () => {

  const routes = [
    {
      path: "/",
      element: <LoginPage />,
    },
    {
      path: "/login",
      element: <LoginPage />,
    },
    {
      path: "/dashboard",
      element: <DashbordPage />,
    },
    {
      path: "/map",
      element: <SimpleMap />,
    },
    {
      path: "/question-based-graph",
      element: <QuestionBasedGraph />,
    },
    {
      path: "/select-database",
      element: <SelectDatabase />,
    },
    {
      path: "/upload-csv",
      element: <UploadCsvPage />,
    },
  ];

  const Router = () => (
    <BrowserRouter basename="/sas">
      <Routes>
        {routes.map((route, index) => (
          <Route key={index} path={route.path} element={<Layout>{route.element}</Layout>} />
        ))}
      </Routes>
    </BrowserRouter>
  );

  return (
    <div style={{ fontFamily: "TeleNeoWeb, sans-serif" }}>
      <Router />
    </div>
  );
};

root.render(<App />);
